import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Workspace from "@/components/Workspace";
import LoginPage from "@/components/LoginPage";
import MenuPage from "@/components/MenuPage";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";

function StaffApp() {
  const { user, booting } = useAuth();
  if (booting || user === undefined) {
    return <div className="flex min-h-screen items-center justify-center bg-sand-100 text-slate-400"><Loader2 className="animate-spin" size={28} /></div>;
  }
  return user ? <Workspace /> : <LoginPage />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<StaffApp />} />
            <Route path="/menu/:spotId" element={<MenuPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
